import React, { ComponentProps } from 'react';

import { Chip } from '~/components/blocks';
import { ReceptionStatus } from '~/components/partials/ReceptionStatus';
import { OutpatientQuestionnaireEntryStatus } from '~/graphql/generated/graphql';

type Props = {
  size?: ComponentProps<typeof Chip>['size'];
  enableNotification: boolean;
  status: OutpatientQuestionnaireEntryStatus;
};

export const OutpatientQuestionnaireEntryStatusLabel = (props: Props) => {
  const { enableNotification, status } = props;

  if (status === 'finished') {
    return <ReceptionStatus label="完了" chipColor="grey03" labelColor="black" />;
  }

  if (enableNotification) {
    return (
      <ReceptionStatus
        label="指導待ち"
        chipColor="blue"
        labelColor="white"
        detailedStatus={{
          label: status === 'entered' ? '未通知' : '通知済',
          color: status === 'entered' ? 'pink' : 'black',
          iconName: 'notification',
        }}
      />
    );
  } else {
    return <ReceptionStatus label="指導待ち" chipColor="blue" labelColor="white" />;
  }
};
